import axios from "axios";
import { handleApiError } from "../Vendor/vendoreffect";
import { getDecryptedData } from "../../Styles/ComponentStyles/formStyles";

const authInstance = axios.create({
  baseURL: "http://154.61.173.102:3006",
  headers: { "content-type": "application/x-www-form-urlencoded" },
});

const accessToken = getDecryptedData("accessToken");

export const walletAddEffect = (formData) => {

  return new Promise((resolve, reject) => {
    authInstance
      .request({
        url: "/wallets/addwallet",
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${accessToken}`,
        },
        data: formData,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {

        const errorFields = handleApiError(error);
   
        reject(errorFields);
      });
  });
};

export const walletUpdateEffect = (formData) => {

  return new Promise((resolve, reject) => {
    authInstance
      .request({
        url: `wallets/updatewallet`,
        method: "PUT",
        data: formData,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {

        resolve(response);
      })
      .catch((error) => {

        reject(
          handleApiError(error)
        );
      });
  });
};

export const walletDeleteEffect = (id) => {
  return new Promise((resolve, reject) => {
    authInstance
      .request({
        url: `/wallets/deletewallet/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {

        resolve(response);
      })
      .catch((error) => {
  
        reject(error);
      });
  });
};

export const walletGetEffect = id => {
  return new Promise((resolve, reject) => {
    authInstance
      .request({
        url: `/wallets/getwallet?wallet_id=${id}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {

        resolve(response);
      })
      .catch((error) => {

        reject(handleApiError(error));
      });
  });
};

export const walletViewAllEffect = (page) => {

  return new Promise((resolve, reject) => {
    authInstance
      .request({
        url: `/wallets/list?pagination_required=true&pageNo=1&pagesize=${page}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {

        resolve(response);
      })
      .catch((error) => {
  
        reject(error);
      });
  });
};